(function () {
  if (window.__apollosCardSwatchesInit) return;
  window.__apollosCardSwatchesInit = true;

  function getCard(el) {
    return el.closest('.apollos-prod');
  }

  function getCardImg(card) {
    return card ? card.querySelector('.apollos-prod__img') : null;
  }

  document.addEventListener(
    'mouseover',
    function (e) {
      var sw = e.target.closest('.apollos-prod__swatch');
      if (!sw) return;
      var preview = sw.getAttribute('data-preview-image');
      if (!preview) return;
      var card = getCard(sw);
      var img = getCardImg(card);
      if (!img) return;
      if (!img.dataset.apollosOriginalSrc) {
        img.dataset.apollosOriginalSrc = img.currentSrc || img.src;
        img.dataset.apollosOriginalSrcset = img.getAttribute('srcset') || '';
      }
      img.setAttribute('srcset', '');
      img.src = preview;
      card.classList.add('apollos-prod--previewing');
    },
    true
  );

  document.addEventListener(
    'mouseout',
    function (e) {
      var sw = e.target.closest('.apollos-prod__swatch');
      if (!sw) return;
      var card = getCard(sw);
      var img = getCardImg(card);
      if (!img || !img.dataset.apollosOriginalSrc) return;
      var related = e.relatedTarget;
      if (related && sw.parentElement && sw.parentElement.contains(related)) return;
      img.src = img.dataset.apollosOriginalSrc;
      img.setAttribute('srcset', img.dataset.apollosOriginalSrcset || '');
      delete img.dataset.apollosOriginalSrc;
      delete img.dataset.apollosOriginalSrcset;
      card.classList.remove('apollos-prod--previewing');
    },
    true
  );
})();
